import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { AlertModule } from '../shared/modules/alert/alert.module';
import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';

@NgModule({
  imports: [CommonModule, LoginRoutingModule, 
    ReactiveFormsModule, AlertModule, FormsModule],
  declarations: [LoginComponent]
})
export class LoginModule {}
